import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { OldEditorReturnService } from './old-editor-return.service';

/**
 * The old order view `/orders/:id` is where the shared editor leaves the operator after «Сохранить». For an operator the NEW pages sent to
 * the editor (see {@link OldEditorReturnService}) it is not the place to be: she is taken back to the list «Заказы» with the order open,
 * or to its full card. Everyone else — the old list, a direct link, «Открыть в старом просмотре» — passes as before.
 */
export const oldEditorReturnGuard: CanActivateFn = (route: ActivatedRouteSnapshot) =>
  inject(OldEditorReturnService).redirectFor(route.paramMap.get('id')) ?? true;
